import { render } from "./DotsVertical.vue?vue&type=template&id=62b8395c"
import script from "./DotsVertical.vue?vue&type=script&lang=js"
export * from "./DotsVertical.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/DotsVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62b8395c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62b8395c', __exports__)) {
    api.reload('62b8395c', __exports__)
  }
  
  module.hot.accept("./DotsVertical.vue?vue&type=template&id=62b8395c", () => {
    api.rerender('62b8395c', render)
  })

}


export default __exports__